export const cardOrientation = {
    minHeight:"93%",
    borderRadius:"10px",
    backgroundColor:"rgba(255, 255, 255, 0.8)"
}